import { IOfficeField } from './office-data.model';

export enum FormFieldControlTypeEnum {
  text = 'text', // string', 'web', 'email'
  number = 'number', // 'byte', 'short', 'int', 'double', 'long'

  checkbox = 'checkbox',
  notes = 'notes',
  combobox = 'combobox',
  richtext = 'richtext',
  date = 'date',
  month = 'month',
  time = 'time',
  percent = 'percent',
  file = 'file',
}

export type FormFieldControlType = `${FormFieldControlTypeEnum}`;
export type OfficeFormTabFields = Record<number, Record<string, IOfficeField[]>>;
export type OfficeFormMode = 'edit' | 'view' | 'add';
